"use client"

import * as React from "react"
import { GlobeIcon } from "@phosphor-icons/react"
import { cn } from "cn"

function hostnameOf(href?: string) {
  if (!href || !/^https?:\/\//.test(href)) return null
  try {
    return new URL(href).hostname
  } catch {
    return null
  }
}

function SiteIcon({ href, className }: { href?: string; className?: string }) {
  const hostname = hostnameOf(href)
  const [failedFor, setFailedFor] = React.useState<string | null>(null)
  if (!hostname || failedFor === hostname) {
    return <GlobeIcon data-slot="site-icon" aria-hidden="true" className={cn("size-3.5 shrink-0", className)} />
  }
  return (
    <img
      data-slot="site-icon"
      src={`https://icons.duckduckgo.com/ip3/${hostname}.ico`}
      alt=""
      aria-hidden="true"
      onError={() => setFailedFor(hostname)}
      className={cn("size-3.5 shrink-0 rounded-[3px] object-contain", className)}
    />
  )
}

export { SiteIcon }
